import React, { useState } from 'react';

const DigitalMarketingPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thank you ${formData.name}! We'll contact you about ${formData.service || 'digital marketing'} soon.`);
    setFormData({
      name: '',
      email: '',
      company: '',
      service: '',
      message: ''
    });
  };

  const services = [
    {
      id: 1,
      title: "SEO Optimization",
      description: "Improve your search engine rankings with our proven SEO strategies to drive organic traffic.",
      icon: "📈"
    },
    {
      id: 2,
      title: "Social Media Marketing",
      description: "Engage with your audience across all major social platforms with tailored content strategies.",
      icon: "📱"
    },
    {
      id: 3,
      title: "Content Marketing",
      description: "Create compelling content that converts visitors into customers and builds brand authority.",
      icon: "✍️"
    },
    {
      id: 4,
      title: "PPC Advertising",
      description: "Maximize ROI with targeted pay-per-click campaigns that deliver measurable results.",
      icon: "🎯"
    },
    {
      id: 5,
      title: "Email Marketing",
      description: "Nurture leads and retain customers with personalized email campaigns that drive action.",
      icon: "📧"
    },
    {
      id: 6,
      title: "Analytics & Reporting",
      description: "Track performance with detailed analytics and insights to optimize your marketing efforts.",
      icon: "📊"
    }
  ];

  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "Marketing Director, TechCorp",
      comment: "Their digital marketing strategy increased our online leads by 240% in just 6 months!",
      avatar: "SJ"
    },
    {
      name: "Michael Chen",
      role: "CEO, Innovate Solutions",
      comment: "The team's expertise in PPC and SEO transformed our digital presence. Highly recommended!",
      avatar: "MC"
    },
    {
      name: "Emily Rodriguez",
      role: "Founder, StartUp Ventures",
      comment: "Outstanding content marketing services that helped us build a loyal customer base.",
      avatar: "ER"
    }
  ];

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      {/* ===== HERO SECTION ===== */}
     <section className="relative overflow-hidden bg-gradient-to-b from-gray-50 to-white py-20 md:py-32">
  <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-10">
    
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

      {/* LEFT CONTENT */}
     <div className="text-left">
  <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight">
    <span className="text-gray-900">
      Digital Marketing That
    </span>
    <br />
    <span className="mt-2 inline-block text-transparent bg-clip-text bg-gradient-to-r from-red-600 via-gray-800 to-blue-600">
      Drives Real Results
    </span>
  </h1>

  <p className="mt-6 text-xl md:text-2xl text-gray-600 max-w-3xl leading-relaxed">
    Human-led strategies combined with data-driven execution to increase your visibility, engagement, and conversions.
  </p>
</div>


      {/* RIGHT IMAGE */}
      <div className="flex justify-center lg:justify-end">
        <img
          src="/digital.png"
          alt="Digital Marketing"
          className="w-full max-w-lg rounded-xl shadow-xl"
        />
      </div>

    </div>
  </div>
</section>


      {/* ===== SERVICES SECTION ===== */}
      <section id="services" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
          <div className="text-center mb-16">
           
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Comprehensive <span className="text-red-600">Digital Marketing</span> Solutions
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We offer end-to-end digital marketing services tailored to your business goals and target audience.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map(service => (
              <div key={service.id} className="bg-white rounded-2xl p-8 border border-gray-200 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 group">
                <div className="text-4xl mb-6">{service.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-red-600 transition-colors">{service.title}</h3>
                <p className="text-gray-600 mb-6">{service.description}</p>
               
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== WHY CHOOSE US SECTION ===== */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
          <div className="text-center mb-16">
           
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Why Choose Our <span className="text-red-600">Marketing Agency</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We combine data-driven strategies with creative execution to deliver measurable results.
            </p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="mb-8">
                <div className="flex items-start mb-8">
                  <div className="w-12 h-12 bg-gradient-to-r from-red-500 to-red-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <span className="text-white font-bold text-xl">1</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Proven Results</h3>
                    <p className="text-gray-600">We have a track record of increasing client revenue by an average of 200% within the first year.</p>
                  </div>
                </div>
                
                <div className="flex items-start mb-8">
                  <div className="w-12 h-12 bg-gradient-to-r from-red-500 to-red-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <span className="text-white font-bold text-xl">2</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Transparent Reporting</h3>
                    <p className="text-gray-600">Get detailed analytics and regular reports so you can see exactly how your campaigns are performing.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-gradient-to-r from-red-500 to-red-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <span className="text-white font-bold text-xl">3</span>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">Custom Strategies</h3>
                    <p className="text-gray-600">We don't believe in one-size-fits-all solutions. Every strategy is tailored to your unique business needs.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="bg-gray-50 border border-gray-200 rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Campaign Performance</h3>
              <div className="space-y-6">
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-medium text-gray-700">ROI Improvement</span>
                    <span className="font-bold text-green-600">+42%</span>
                  </div>
                  <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div className="h-2 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full w-3/4"></div>
                  </div>
                </div>
                
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-medium text-gray-700">Lead Generation</span>
                    <span className="font-bold text-blue-600">+65%</span>
                  </div>
                  <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div className="h-2 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full w-4/5"></div>
                  </div>
                </div>
                
                <div>
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-medium text-gray-700">Brand Awareness</span>
                    <span className="font-bold text-purple-600">+38%</span>
                  </div>
                  <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                    <div className="h-2 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full w-2/3"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    

      
    </div>
  );
};

export default DigitalMarketingPage;